<template>
    <form action v-on:submit.prevent>
        <ProgressHeader :step="step"></ProgressHeader>
        <PropertyLocation
            v-if="step === 1"
            :step="step"
            :properties="properties"
            @next-step="next"
            @format-property="formatLocation"
        ></PropertyLocation>
        <PropertyValue
            v-if="step === 2"
            :step="step"
            @next-step="next"
            @prev-step="prev"
            @prev-step-coverage="prevStepCoverage"
            :payment="payment"
            :properties="properties"
            :property="property"
            @format-payment="formatPayment"
            @format-property="formatValue"
            @set-total-value="setTotalValue"
            @set-property-value="setPropertyValue"
        ></PropertyValue>
        <PropertyDescription
            v-if="step === 3"
            :step="step"
            @next-step="next"
            @prev-step="prev"
            :properties="properties"
            :property="property"
            @format-property="formatDescription"
            @set-same-as-property="setSameAsProperty"
            @step-one="stepOne"
        ></PropertyDescription>
        <CoverageRates
            v-if="step === 4"
            :step="step"
            @next-step="next"
            @prev-step="prev"
            @set-step="setStep"
            @remove-property="removeProperty"
            :property="property"
            :properties="properties"
            :payment="payment"
        ></CoverageRates>
        <PropertyOwner
            v-if="step === 5"
            :step="step"
            @next-step="next"
            @next-step-payment="nextStepPayment"
            @prev-step="prev"
            :property="property"
            :properties="properties"
            :payment="payment"
            :triaItem="triaItem"
            :propertyOwner="propertyOwner"
            @format-property="formatOwner"
            @set-premium="setPremium"
            @set-tria="setTria"
        ></PropertyOwner>
        <TerrorismInsurance
            v-if="step === 6"
            :step="step"
            @next-step="next"
            @prev-step="prev"
            :property="property"
            :properties="properties"
            :payment="payment"
            :triaItem="triaItem"
            @format-property="formatTria"
            @set-premium="setPremium"
            @set-tria="setTria"
        ></TerrorismInsurance>
        <Payment
            v-if="step === 7 || step === 8"
            :step="step"
            :properties="properties"
            :propertyOwner="propertyOwner"
            :payment="payment"
            :triaItem="triaItem"
            @format-property="formatPayment"
            @format-billing="formatBilling"
            @finalize="finalize"
            @set-score="setScore"
            @prev-step="prev"
            @next-step="next"
            @prev-step-owner="prevStepOwner"
        ></Payment>
    </form>
</template>

<script>
import { mapActions } from "vuex";
import PropertyLocation from "./PropertyLocation.vue";
import PropertyValue from "./PropertyValue.vue";
import PropertyDescription from "./PropertyDescription.vue";
import CoverageRates from "./CoverageRates.vue";
import PropertyOwner from "./PropertyOwner.vue";
import Payment from "./Payment.vue";
import TerrorismInsurance from "./TerrorismInsurance.vue";
import { ProgressHeader } from "../../style";
import { CREATE_PURCHASE, FETCH_NAIC_CODES } from "../../store/types";
export default {
  name: "QuotationForm",
  components: {
    PropertyLocation,
    PropertyValue,
    PropertyDescription,
    CoverageRates,
    PropertyOwner,
    Payment,
    TerrorismInsurance,
    ProgressHeader
  },
  computed: {
    propertyElement() {
      return this.properties[this.property - 1];
    }
  },
  data() {
    return {
      step: 1,
      property: 1,
      properties: [],
      propertyOwner: {},
      triaItem: {},
      payment: {
        deductible: 0,
        yearlyPremium: 0,
        premiumBilling: "monthly",
        totalValue: 0,
        triaPremium: 0
      },
      billing: {},
      updateState: false
    };
  },
  created() {
    this.fetchNaicCodes();
  },
  methods: {
    ...mapActions({
      createPurchase: CREATE_PURCHASE,
      fetchNaicCodes: FETCH_NAIC_CODES
    }),
    prev() {
      this.step--;
    },
    prevStepCoverage(numberValue) {
      if (parseInt(numberValue) === 0) {
        this.properties = this.properties.filter(prop => {
          return parseInt(prop.value) > 0;
        });
        this.property = this.properties.length;
      }
      this.step = 4;
    },
    next() {
      this.step++;
    },
    nextStepPayment() {
      this.step = 7;
    },
    prevStepOwner() {
      this.step = 5;
    },
    stepOne() {
      this.updateState = true;
      this.step = 1;
    },
    setStep() {
      const propertyCount = this.properties.length;
      this.step = 2;
      this.property = propertyCount + 1;
      this.properties[propertyCount] = {
        locationState: this.properties[0].locationState,
        value: 0
      };
    },
    formatLocation(state) {
      if (!this.updateState) {
        let firstProperty = { locationState: state, value: 0 };
        this.properties.pop(firstProperty);
        this.properties.push(firstProperty);
      } else {
        this.properties[this.property - 1].locationState = state;
      }
      this.updateState = false;
    },
    formatValue(propertyValue) {
      Object.assign(this.propertyElement, propertyValue);
    },
    formatDescription(propertyDescription) {
      Object.assign(this.propertyElement, propertyDescription);
    },
    formatOwner(propertyOwner) {
      Object.assign(this.propertyOwner, propertyOwner);
    },
    formatTria(triaItem) {
      Object.assign(this.triaItem, triaItem);
    },
    formatPayment(payment) {
      Object.assign(this.payment, payment);
    },
    formatBilling(billing) {
      Object.assign(this.billing, billing);
    },
    setScore(score) {
      Object.assign(this.propertyOwner, { recaptchaScore: score });
    },
    finalize() {
      this.payment.totalValue = 0;
      this.properties.forEach(prop => {
        this.payment.totalValue += prop.value;
      });

      const data = {
        properties: this.properties,
        propertyOwner: this.propertyOwner,
        payment: this.payment,
        billing: this.billing
      };

      this.createPurchase({
        data: data
      })
        .then(() => {
          this.$router.push("/success");
        })
        .catch(() => {});
    },
    removeProperty(propIndex) {
      let poppedProperty = this.properties.filter((prop, index) => {
        return index === propIndex;
      });
      this.properties = this.properties.filter((prop, index) => {
        return index !== propIndex;
      });
      this.properties.forEach(prop => {
        if (
          poppedProperty[0].street === prop.street &&
                    poppedProperty[0].city === prop.city &&
                    poppedProperty[0].unitNumber === prop.unitNumber &&
                    poppedProperty[0].state === prop.state &&
                    poppedProperty[0].zip === prop.zip
        ) {
          delete prop.street;
          delete prop.city;
          delete prop.unitNumber;
          delete prop.state;
          delete prop.zip;
        }
        if (
          poppedProperty[0].lien &&
                    prop.lien &&
                    poppedProperty[0].lien.name === prop.lien.name &&
                    poppedProperty[0].lien.street === prop.lien.street &&
                    poppedProperty[0].lien.unitNumber ===
                        prop.lien.unitNumber &&
                    poppedProperty[0].lien.city === prop.lien.city &&
                    poppedProperty[0].lien.state === prop.lien.state &&
                    poppedProperty[0].lien.zip === prop.lien.zip
        ) {
          delete prop.lien;
        }
      });

      if (this.properties.length == 0) {
        this.step = 1;
        this.property = 1;
        this.properties = [];
        this.propertyOwner = {};
        this.triaItem = {};
        this.payment = {
          deductible: 0,
          yearlyPremium: 0,
          premiumBilling: "monthly",
          totalValue: 0,
          triaPremium: 0
        };
      } else {
        this.property = this.properties.length;
        this.recomputeTotalValue();
      }
    },
    recomputeTotalValue() {
      this.payment.yearlyPremium = this.computeTotalPropValue();
    },
    computeTotalPropValue() {
      let price = 0;
      this.properties.forEach(property => {
        price += parseFloat(property.premium);
      });
      return price;
    },
    setPremium(premium) {
      this.payment.triaPremium = premium;
    },
    setTria(tria) {
      this.payment.availTria = tria;
    },
    setTotalValue(totalValue) {
      this.payment.totalValue = totalValue;
    },
    setPropertyValue(propertyValue) {
      this.properties[this.property - 1].value = propertyValue;
    },
    setSameAsProperty() {
      this.properties[this.property - 1]["sameAsPropertyOne"] = 1;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/style/_variables.scss";
form {
    width: 100%;
    max-width: 940px;
    margin: auto;
    padding: $padding-xxl $padding-lg;
    border-radius: 5px;
    border: 1px solid $background-gray;
    background-color: $white;
    position: relative;
    @include breakpoint(mobile-hd-width) {
        padding: $padding-xxl;
    }
}
</style>
